import React, { useState, useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom"; 
import Loader from "../../components/Loader";
import Image from "../../components/Image";
import DeleteModel from "../../components/Products/DeleteModel";
import { useProduct } from "../../hooks/useProduct";
import { useTranslation } from "react-i18next";
import { useAuth } from "../../contexts/AuthProvider";
import { fetchCategories } from "../../utils/dataFetcher";
import { API_URL } from "../../utils/config";
const baseUrl = API_URL;
const ProductDetails = () => {
  const { t, i18n } = useTranslation("addProductsHeader");
  const lang = i18n.language;
  const { id } = useParams();
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [categories, setCategories] = useState([]);
  const navigate = useNavigate();

  const { product, oldImagesFiles: images, loading, error } = useProduct();
  const [isDeleting, setIsDeleting] = useState(false);
  const { isAuthenticated, userRole } = useAuth();

  

  const handleDelete = () => {
    setShowDeleteModal(true);
  };

  const getLangFromLocalStorage = () => {
    return localStorage.getItem("language") || "en";
  };
 const isArabic = lang === "ar";
  const confirmDelete = async () => {
    if (isDeleting) return;
    setIsDeleting(true);

    console.log("Product ID:", id);
    if (!isAuthenticated) {
      localStorage.removeItem("user");
      navigate("/login");
      return;
    }

    try {
      const response = await fetch(`${baseUrl}/api/v1/attnd-supplier/services/${id}`, {
        method: "DELETE",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          lang: getLangFromLocalStorage(),

        },
      });

      const data = await response.json(); 
      if (!response.ok) {
        window.alert(data.error || "An unexpected error occurred");
        setIsDeleting(false);
        return;
      }

      setShowDeleteModal(false);
      navigate("/products", { replace: true });
    } catch (err) {
      console.error("Error deleting product:", err);
      window.alert(err.message || "Network error occurred");
    } finally {
      setIsDeleting(false);
    }
  };

  const cancelDelete = () => {
    setShowDeleteModal(false);
  };

  useEffect(() => {
      const fetchCategoriesData = async () => {
      const data = await fetchCategories(lang);
      setCategories(data.data);
    };
    fetchCategoriesData();
    if (product) {
      console.log(product);
      console.log(images);
    }
  }, [product, images]);

  if (loading) {
    return (
      <div className="loader-container">
        <Loader />
      </div>
    );
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  return (
    <div className="flex flex-col gap-10 my-16 mx-5">
      <div
        onClick={() => navigate(-1, { replace: true })}
        className="p-3 rounded-full w-fit flex flex-row gap-4 items-center bg-white no-underline cursor-pointer"
      >
        <img
          src="/arrow-circle-left.svg"
          alt={t("productDetails.navigation.backAlt")}
          className="w-6 h-6"
          style={{rotate: lang === "ar" && "180deg"}}
        />
        <p className="text-base font-semibold text-[#292929]">
          {t("productDetails.navigation.back")}
        </p>
      </div>
      <div className="flex flex-row gap-5">
        <div className="max-w-[464px] grid grid-cols-3 gap-x-4 gap-y-6">
          {images &&
            images.length > 0 &&
            images.map((image, index) => (
              <div
                key={index}
                className={`relative overflow-hidden ${
                  index === 0 ? "col-span-3 w-full h-[425px]" : ""
                }`}
              >
                <Image
                  src={image}
                  Class={"w-full h-full object-cover rounded-lg"}
                />
              </div>
            ))}
        </div>

        {product && (
          <div className="w-[464px] flex flex-col gap-6">
            <div className="flex flex-col gap-2">
              <h1 className="text-2xl font-extrabold text-[#292929]">
                {isArabic ? product.name_ar : product.name}
              </h1>
              <p className="text-base text-[#464646] font-normal">
                {categories.find(cat => cat.id === product.type)?.name || ''}
              </p>
            </div>

            <div className="flex flex-col gap-4 border-2 border-primary rounded-lg p-4">
              <h2 className="text-base text-primary font-semibold">
                {t("productDetails.cost.heading")}
              </h2>
              <div className="flex justify-between items-center">
                <p className="text-base text-[#464646] font-semibold">
                  {isArabic ? product.name_ar : product.name}
                </p>
                <p className="text-base text-[#464646] font-semibold">
                  {product.price}{" "}
                  <span className="font-normal">
                    {t("productDetails.cost.unit")}
                  </span>
                </p>
              </div>
            </div>
            <p className="text-base text-[#464646] font-normal leading-6 text-justify">
              {isArabic ? product.description_ar : product.description}
            </p>
            {/* Action buttons - only show if user is not viewer */}
            {userRole !== 'viewer' && (
              <div className="flex flex-col gap-6">
                <Link
                  to={`/products/edit-product/${id}`}
                  className="text-center no-underline border-2 border-primary py-3 rounded-lg cursor-pointer text-base font-bold text-white bg-primary"
                >
                  {t("productDetails.buttons.edit")}
                </Link>
                <button
                  className="text-center no-underline border-2 border-primary py-3 rounded-lg cursor-pointer text-base font-bold text-primary bg-white"
                  onClick={handleDelete}
                >
                  {t("productDetails.buttons.delete")}
                </button>
              </div>
            )}
          </div>
        )}
      </div>

      {showDeleteModal && (
        <DeleteModel
          confirmDelete={confirmDelete}
          cancelDelete={cancelDelete}
          isDeleting={isDeleting}
        />
      )}
    </div>
  );
};

export default ProductDetails;
